import { createSelector } from 'reselect';
import { ff } from '@atlassian/jira-feature-flagging';
import { findMentionsInAdfContent } from '@atlassian/jira-issue-view-common-utils/src/mentions';
import { DESCRIPTION } from '@atlassian/jira-issue-view-configurations';
import { fieldSelector } from '../common/state/selectors/field-selector';
import { entitiesCommentsSelector } from './comment-selector';

export const mentionsInDescriptionSelector = createSelector(
	fieldSelector(DESCRIPTION),
	(description) => {
		if (
			ff('sea-2350-analytics-for-mentions-in-board-and-backlog_2gkji') &&
			description?.adfValue?.content
		) {
			return findMentionsInAdfContent(description.adfValue.content);
		}
		return [];
	},
);

export const mentionsInCommentsSelector = createSelector(entitiesCommentsSelector, (comments) => {
	if (ff('sea-2350-analytics-for-mentions-in-board-and-backlog_2gkji')) {
		if (comments && Object.values(comments) && Object.values(comments).length > 0) {
			const content = Object.values(comments).flatMap((item) => item?.bodyAdf?.content);
			return content ? findMentionsInAdfContent(content) : [];
		}
		return [];
	}
	return [];
});
